export const AdditionalInformationData = (selectedTag, formData, selectedTrfId) => ({
    rows: [
        {
            key: 1,
            fields: [{
                key: 'F17Mi',
                value: formData.F17Mi ?? selectedTag.Mi,
            },
            {
                key: 'F87MiDescription',
                value: formData.F87MiDescription,
            },
            {
                key: 'F88Mp',
                value: formData.F88Mp ?? selectedTag.MaintenanceItemPm,
            },
            {
                key: 'F20Mo',
                value: formData.F20Mo ?? selectedTag.HdWorkOrder,
            },
            {
                key: 'F91TrfId',
                value: selectedTrfId ?? (formData.F91TrfId ?? (selectedTag.TrfId ? selectedTag.TrfId.trim() : '')),
            },
            {
                key: 'F92RegionDocId',
                value: formData.F92RegionDocId ?? selectedTag.BpRegion,
            },
            {
                key: 'RowId',
                value: formData.RowId,
            }]
        }
    ]

});
